import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../ui/button';
/**
 * Presentational fallback shown by an error boundary. Framework-agnostic — it
 * leaves error capture (Sentry, logging) and any DOM wrapper (e.g. Next's
 * `<body>`) to the boundary that renders it.
 */
export function ErrorFallback({ onReset, title = 'Oops, there is an error!', }) {
    return (_jsx("div", { className: "backdrop-blur sticky flex h-screen w-full items-center justify-center bg-background/50", children: _jsxs("div", { className: "gap-4 px-10 py-8 flex max-w-[440px] flex-col items-start rounded-md bg-card", children: [_jsx("h2", { children: title }), _jsx(Button, { type: "button", onClick: onReset, children: "Try again?" })] }) }));
}
